import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import classnames from 'classnames';

import infoIcon from '@assets/icons/info-gray.png';
import commonsMessages from '@shared/messages';
import FormatPrice from '@shared/containers/FormatPrice';
import ActionLine from '../ActionLine';
import { StyledPriceLine, InfoIcon } from './StyledPriceLine';

export const TYPES = {
  TOTAL: 'total',
  SUB_TOTAL: 'subtotal',
  MODIFIER: 'modifier',
};

function PriceLine({
  text,
  price,
  type,
  checkout,
  onClick,
  intl,
  isNegative,
  infoButtonClick,
  className,
  content,
}) {
  const { formatMessage } = intl;
  const contentClass = classnames(type, { checkout }, 'format');

  return (
    <StyledPriceLine className={className}>
      <div className={contentClass}>
        <span className="left">{text}</span>
        {infoButtonClick && (
          <InfoIcon src={infoIcon} onClick={infoButtonClick} />
        )}
        {content}
        {onClick && (
          <ActionLine
            onClick={onClick}
            text={formatMessage(commonsMessages.edit)}
          />
        )}
        <FormatPrice isNegative={isNegative} className="right" value={price} />
      </div>
    </StyledPriceLine>
  );
}

PriceLine.propTypes = {
  text: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  type: PropTypes.oneOf([TYPES.TOTAL, TYPES.SUB_TOTAL, TYPES.MODIFIER]),
  checkout: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isNegative: PropTypes.bool,
  infoButtonClick: PropTypes.func,
  intl: intlShape.isRequired,
  content: PropTypes.element,
};

PriceLine.defaultProps = {
  type: TYPES.TOTAL,
  checkout: false,
  infoButtonClick: null,
  content: null,
};

export { PriceLine as PriceLineTest };
export default injectIntl(PriceLine);
